import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';
import withAuth from '../components/withAuth';

function Explore() {
    const [items, setItems] = useState([]);

    useEffect(() => {
        window.wait().then(()=>{
        fetch(`${window.app.HOST}/nft?owner_address=`)
            .then(res=>res.json())
            .then(items=>setItems(items));
        });
    }, []);

    return (
        <div id="wrapper" className="explore">
            {/* Header component */}
            <Header />

            <div className="no-bottom no-top" id="content">
                <div id="top"></div>

                <section id="subheader" className="minimal">
                    <div className="center-y relative text-center">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <h1>Explore</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section aria-label="section" id="section-explore">
                    <div className="container" style={{ backgroundSize: 'cover' }}>
                        <div className="row cols-5 wow fadeIn animated">
                            <div className="col-lg-12" style={{ backgroundSize: 'cover' }}>
                                <div className="items_filter" style={{ backgroundSize: 'cover' }}>
                                    <button className="button" data-filter=".artworks">NFTs</button>
                                    <button className="button" data-filter=".artworks">Collections</button>
                                    <button className="button" data-filter=".artworks">Galleries</button>
                                    <button className="button" data-filter=".artworks">Artists</button>
                                </div>
                            </div>

                            <div class="col-md-3 col-lg-4 mb30 item">
                                <div class="nft_coll">
                                    <div class="nft_wrap">
                                        <a href="/item"><img src="images/items/big-6.jpg" class="lazy img-fluid" alt="" /></a>
                                    </div>
                                    <div className="nft__item_info">
                                        <a href="/item">
                                            <h3>Abstraction #256</h3>
                                        </a>
                                        <a href="/profile">
                                        <h6 className='artist'>@NFTtalks</h6>
                                        </a>
                                        <div className="nft__item_action">
                                            <a href="/item">Buy now</a>
                                        </div>
                                        <div className="nft__item_price">
                                            0.08 TON
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {items.map(({address,name,description,image,price, status, artist_name})=>(
                            <div class="col-md-3 col-lg-4 mb30 item">
                                <div class="nft_coll">
                                    <div class="nft_wrap">
                                        <a href={`item?a=${address}`}><img src={image.replace('ipfs://', 'https://ipfs.io/ipfs/')} class="lazy img-fluid" alt="" /></a>
                                    </div>
                                    <div className="nft__item_info">
                                        <a href={`item?a=${address}`}>
                                            <h3>{name}</h3>
                                        </a>
                                        <a href="/profile">
                                        <h6 className='artist shortened-address float'>{artist_name?`@${artist_name}`:'@NFTtalks'}</h6>
                                        </a>
                                        <div className='clearfix'></div>
                                        <div className="nft__item_action">
                                            <a href={`item?a=${address}`}>Buy now</a>
                                        </div>
                                        <div className="nft__item_price">
                                            {status=='sold'?'SOLD' : price ? `${price} TON` : '-'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            ))}
                            {/* Additional items can be added similarly */}

                            <div className="col-md-12 text-center">
                                {/* <a href="#" id="loadmore" className="btn-main wow fadeInUp lead animated" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>Load more</a> */}
                                <a href="#" id="loadmore" class="btn-list">View more</a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* Footer component */}
            <Footer />
        </div>
    );
}

export default withAuth(Explore);